// extracted by mini-css-extract-plugin
export var bgWrapper = "style-module--bgWrapper--E-VOq";
export var container = "style-module--container--Z7bpE";
export var divider = "style-module--divider--+rBzT";
export var dotsWrapper2 = "style-module--dotsWrapper2--3DhEP";
export var header = "style-module--header--6tFAa";
export var highlight = "style-module--highlight--BV9OR";
export var img = "style-module--img--mJVbK";
export var imgWrapper = "style-module--imgWrapper--ZAjSW";
export var line = "style-module--line--UBMBA";
export var otherProjects = "style-module--otherProjects--xxi9M";
export var otherWrapper = "style-module--otherWrapper--wf7Hc";
export var others = "style-module--others--yNR5g";
export var partnersTitle = "style-module--partnersTitle--3anxF";
export var place = "style-module--place--dp3dM";
export var project = "style-module--project--RmGfh";
export var projectTitle = "style-module--projectTitle--x7gRv";
export var root = "style-module--root--qPIay";
export var summaryText = "style-module--summaryText--Dv-OL";
export var text = "style-module--text--MfpXX";
export var title = "style-module--title--e-4El";
export var winners = "style-module--winners--Ezllw";
export var winnersImg = "style-module--winnersImg--NAvqI";
export var winnersTitle = "style-module--winnersTitle--qE7l5";